import type {
  AdminBookingListResult,
  AdminDamageReportResult,
  AdminListingDetail,
  AdminListingListItem,
  AdminListingListResult,
  BookingListParams,
  DisputeListParams,
  ListingListParams,
} from '@/types/rental.types';
import { cleanParams } from '@/utils/params.util';

import { apiClient } from './api.service';

export const rentalsApi = {
  listListings: (params: ListingListParams = {}) =>
    apiClient
      .get<AdminListingListResult>('/admin/listings', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  getListing: (id: string) =>
    apiClient.get<AdminListingDetail>(`/admin/listings/${id}`).then((r) => r.data),

  removeListing: (id: string) =>
    apiClient.post<AdminListingListItem>(`/admin/listings/${id}/remove`).then((r) => r.data),

  restoreListing: (id: string) =>
    apiClient.post<AdminListingListItem>(`/admin/listings/${id}/restore`).then((r) => r.data),

  listActiveRentals: (params: BookingListParams = {}) =>
    apiClient
      .get<AdminBookingListResult>('/admin/rentals', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  listDisputes: (params: DisputeListParams = {}) =>
    apiClient
      .get<AdminDamageReportResult>('/admin/disputes', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  listCampusOptions: () =>
    apiClient
      .get<{ id: string; name: string }[]>('/admin/users/campuses')
      .then((r) => r.data),
};
